import React from 'react'
import Popup from '../Popup.js'
import "./Tooltip.scss"

const Tooltip = ({children, label, placement, display, disabled, delay, className, icon, padding, toggleTooltip, maxWidth, truncate, innerClassName, outerStyle}) => {

	return (
		<Popup
			className={`${className ? " " + className : ""}${truncate ? " truncate" : ""}`}
			innerClassName={innerClassName}
			delay={delay}
			hoverOnly={!toggleTooltip}
			disabled={disabled}
			outerStyle={outerStyle}
			popupElement={
				<div
					className={`tooltip-popup-wrapper${padding ? " padding-" + padding : ""}${icon ? " tooltip-with-icon" : ""}`}
					style={{ maxWidth: maxWidth ? maxWidth : "", overflowWrap: maxWidth ? "break-word" : "" }}
				>
					{icon && icon}
					{label}
				</div>
			}
			placement={placement ? placement : "top"}
			display={display ? display : "inline-block"}
		>
			{truncate ? <div className="truncate">{children}</div> : children}
		</Popup>
	);
}

export default Tooltip;